import { HttpClient, HttpEvent, HttpHeaders, HttpResponse } from "@angular/common/http";
import { map, Observable, tap } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { Injectable } from "@angular/core";
import { AgentConfirmationDto, AgentDto, AgentFieldValidationDto, AgentProvisionFormDataDto, DocumentDto, ImageDto, ImageTypeEnum, MsisdnDto, PartnerDto, ResultListDto, SearchResultDocumentDto, SearchResultMsisdnDto, SubscriberFullDto } from "./dto";

@Injectable({
	providedIn: 'root'
})
export class HttpConfirmationService extends AbstractHttpService {
	constructor(httpClient: HttpClient) {
		super(httpClient, '/api/agent_confirmation', undefined);
	}
	findByCode(code: string): Observable<AgentConfirmationDto>{
		return super.doGet(false, `/code:${code}`)
	}
	findById(id: number): Observable<AgentConfirmationDto>{
		return super.doGet(false, `/${id}`)
	}
	decline(id: number, otp: string): Observable<AgentConfirmationDto>{
		return super.doPost(false, `/${id}/decline`, otp);
	}
	accept(id: number, otp: string): Observable<AgentConfirmationDto>{
		return super.doPost(false, `/${id}/accept`, otp);
	}
}
